<div
  [hidden]="!showBanner || channels.length < 1"
  class="alert-banner-container grey-background body-sm"
  (mouseenter)="pauseCarousel(true)"
  (mouseleave)="pauseCarousel(false)"
>
  <div
    class="py-2 container carousel-parent-container"
    data-automation-id="alert-parent-container"
  >
    <div
      *ngIf="channels.length > 1"
      class="arrow-btn-container me-4"
      data-automation-id="slideCounter"
    >
      <a
        role="button"
        type="button"
        class="header-icon"
        (click)="previousMessage($event)"
        data-automation-id="arrow-left"
      >
        <img src="assets/chevron-left.svg" alt="arrow pointing left" />
      </a>
      {{ currentSlide + 1 }} of {{ channels.length }}
      <a
        role="button"
        type="button"
        class="header-icon"
        (click)="nextMessage($event)"
        data-automation-id="arrow-right"
      >
        <img src="assets/chevron-right.svg" alt="arrow pointing right" />
      </a>
    </div>
    <ng-container *ngIf="isBrowser; else firstAlert">
      <ngb-carousel
        class="carousel-dark carousel-main flex-grow-1"
        #carousel
        [interval]="6000"
        [pauseOnHover]="true"
        [pauseOnFocus]="true"
        (slide)="onSlide($event)"
      >
        <ng-template
          ngbSlide
          *ngFor="let channel of channels; index as i"
          [id]="'alert-' + i"
        >
          <ng-container
            *ngTemplateOutlet="alertItem; context: { $implicit: channel.body }"
          ></ng-container>
        </ng-template>
      </ngb-carousel>
      <span class="alerts-detail" *ngIf="channels.length > 1"
        >View {{ channels.length }} new alerts...</span
      >
      <span class="alerts-detail" *ngIf="channels.length === 1">
        <div
          class="alert-html"
          data-automation-id="alert-text"
          [innerHTML]="channels[0].body"
        ></div
      ></span>
      <div class="btn-close-container mw-4">
        <a
          role="button"
          type="button"
          class="toggle-button"
          data-automation-id="toggle-button"
          (click)="showMobileAlerts = !showMobileAlerts"
          *ngIf="!showMobileAlerts && channels.length > 1"
        >
          <digital-platform-icon
            class="expand-btn header-icon"
            [width]="24"
            [height]="24"
            icon="chevron-down"
          ></digital-platform-icon>
        </a>
        <a
          role="button"
          type="button"
          class="toggle-button"
          data-automation-id="toggle-button"
          (click)="showMobileAlerts = !showMobileAlerts"
          *ngIf="showMobileAlerts && channels.length > 1"
        >
          <digital-platform-icon
            class="expand-btn header-icon"
            [width]="24"
            [height]="24"
            icon="chevron-up"
          ></digital-platform-icon>
        </a>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
          (click)="showBanner = false"
          data-automation-id="button-close-alert"
        ></button>
      </div>
    </ng-container>
    <ng-template #firstAlert>
      <ng-container *ngIf="channels.length > 0">
        <ng-container
          *ngTemplateOutlet="
            alertItem;
            context: { $implicit: channels[0].body }
          "
        ></ng-container>
      </ng-container>
      <button
        type="button"
        data-bs-dismiss="alert"
        aria-label="Close"
        data-automation-id="button-close-alert"
        class="btn-close ng-tns-c79-0"
      ></button>
    </ng-template>
  </div>
  <div
    class="non-carousel-container container"
    [@accordionOpenClose]="showMobileAlerts"
    *ngIf="showMobileAlerts && showBanner"
  >
    <div *ngFor="let channel of channels; index as i">
      <div
        class="alert-html"
        data-automation-id="mobile-view-alert-text"
        [innerHTML]="channel.body"
        [class.alert-html-border]="channels.length - 1 !== i"
      ></div>
    </div>
  </div>
</div>

<ng-template #alertItem let-body>
  <div
    class="alert-html"
    [innerHTML]="body"
    data-automation-id="alert-text"
  ></div>
</ng-template>
